<template>
    <div>
        <div class="modal fade" id="pageEditorModal" tabindex="-1" role="dialog" aria-labelledby="confirmModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="confirmModalLabel">Page Editor</h5>
                        <button type="button" class="btn-close" @click="noHandler" aria-label="Close">

                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="row mb-3">
                                <label for="nameInput" class="col-sm-3 col-form-label">Name</label>
                                <div class="col-sm-9">
                                    <input id="nameInput" type="text" class="form-control" placeholder="Page name"
                                           v-model="page.title">
                                    <div v-if="showErrorMessage && page.title.length === 0" class="invalid-title">
                                        A page title is required.
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-3">
                                <label class="col-sm-3 col-form-label">Description</label>
                                <div class="col-sm-9">
                                    <textarea id="descInput" type="text" class="form-control"
                                              placeholder="Page description"
                                              v-model="page.layout.description"></textarea>
                                </div>
                            </div>

                            <div class="row ms-1 mb-3">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="showNavBarCheckbox"
                                           v-model="page.show_nav">
                                    <label class="form-check-label" for="showNavBarCheckbox">
                                        Display top nav bar for this page?
                                    </label>
                                </div>
                            </div>

                            <div class="row ms-1 mb-3">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="showFooterCheckbox"
                                           v-model="page.show_footer">
                                    <label class="form-check-label" for="showFooterCheckbox">
                                        Display footer for this page?
                                    </label>
                                </div>
                            </div>

                            <div class="row ms-1 mb-3">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" id="homePageCheckbox"
                                           v-model="page.home_page">
                                    <label class="form-check-label" for="homePageCheckbox">
                                        Set as home page?
                                    </label>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary" @click="yesHandler">Ok</button>
                        <button type="button" class="btn btn-secondary" @click="noHandler">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import PageService from "../../services/PageService";

    export default {
        name: 'PageModal',
        props: {
            yesEvent: Function,
            page: Object
        },
        data() {
            return {
                model: webase.model,
                service: new PageService(),
                showErrorMessage: false,
                currentModal: null,
                modalElement: null,
            }
        },
        mounted() {
            this.modalElement = document.getElementById('pageEditorModal')
            this.currentModal = new bootstrap.Modal(this.modalElement)
            this.modalElement.addEventListener('hidden.bs.modal', this.onModalHidden)
            this.currentModal.show()
        },
        beforeUnmount() {
            this.modalElement.removeEventListener('hidden.bs.modal', this.onModalHidden)
        },
        methods: {
            onModalHidden() {
                this.$emit('noEvent')
            },
            noHandler(e) {
                this.currentModal.hide()
            },
            yesHandler(e) {
                this.showErrorMessage = false

                if (!this.page.title) {
                    this.showErrorMessage = true
                    return
                }

                if (this.page.slug) {
                    this.update()
                } else {
                    this.create()
                }

                // hide the modal
                this.noHandler()
            },
            update() {

                let request = {
                    page: {
                        title: this.page.title,
                        layout: this.page.layout,
                        show_nav: this.page.show_nav,
                        show_footer: this.page.show_footer,
                        home_page: this.page.home_page,
                    }
                }

                this.service.update(this.page.slug, request).then((message) => {
                    let currentPage = this.model.website.webpages.filter(webpage => (webpage.slug === this.page.slug))[0]
                    currentPage.title = this.page.title
                }).catch((message) => {
                    console.log('error updating page')
                    console.log(message)
                })
            },

            create() {
                let request = {
                    page: {
                        title: this.page.title,
                        website_id: this.model.website.id,
                        layout: this.page.layout,
                        show_nav: this.page.show_nav,
                        show_footer: this.page.show_footer,
                        home_page: this.page.home_page,
                    }
                }

                this.service.create(request).then((webpage) => {
                    // call the parent's "yesEvent"
                    if (this.yesEvent) {
                        this.yesEvent(webpage)
                    }
                }).catch((message) => {
                    console.log('error creating page')
                    console.log(message)
                })
            }
        }
    }
</script>
